import { gsap, ScrollTrigger } from 'gsap/all';
import SplitText from "../__vendor/SplitText.min.js";

gsap.registerPlugin(ScrollTrigger);

const HomeWorkSection = () => {
        const text = new SplitText('.works h2, .works p', { type: "chars" });

        gsap.set(text.chars, {
            opacity: 0,
            y: 30
        });
        
        gsap.set('.works h2', {
            opacity: 1,
        });

        const workTl = gsap.timeline({
            paused: true
        });

        workTl.to(text.chars, {
            y: 0,
            opacity: 1,
            stagger: 0.075
        }, 0.15).to('.works h2 span', {
            left: '13.5vw',
            ease: 'power1.inOut'
        }, 0.75);

        ScrollTrigger.create({
            scroller:'[data-scroll-container]',
            trigger: '.works',
            start: 'top bottom',
            end: 'bottom top',
            animation: workTl,
            toggleActions: 'play none none none',
        });

        const infoTl = gsap.timeline({
            paused: true
        });

        infoTl.to(text.chars, {
            y: 0,
            opacity: 1,
            stagger: 0.01
        }, 0.1);

        ScrollTrigger.create({
            scroller:'[data-scroll-container]',
            trigger: '.works p',
            start: 'top bottom',
            end: 'bottom top',
            animation: infoTl,
            toggleActions: 'play none none none',
        });
};

export default HomeWorkSection;
